document.addEventListener('DOMContentLoaded', function() {
    // Announcement bar close
    document.querySelectorAll('.announcement-bar-close').forEach(button => {
        button.addEventListener('click', () => {
        const bar = button.closest('.announcement-bar');
        if (bar) bar.remove();
        });
    });

    // FAQ accordions (scoped per container)
    document.querySelectorAll('#FaqAccordion').forEach(container => {
        const accordionMode = container.dataset.accordionMode === 'true';
        const openFirst = container.dataset.openFirst === 'true';

        container.querySelectorAll('[data-faq-trigger]').forEach(btn => {
        btn.addEventListener('click', () => {
            const item = btn.closest('[data-faq-item]');
            const panel = item.querySelector('[data-faq-panel]');
            const icon = item.querySelector('[data-faq-icon]');
            const isOpen = btn.getAttribute('aria-expanded') === 'true';

            if (accordionMode) {
            container.querySelectorAll('[data-faq-item]').forEach(other => {
                if (other !== item) {
                other.querySelector('[data-faq-panel]').classList.add('hidden');
                other.querySelector('[data-faq-trigger]').setAttribute('aria-expanded', 'false');
                const otherIcon = other.querySelector('[data-faq-icon]');
                if (otherIcon) otherIcon.style.transform = '';
                other.style.borderColor = 'var(--color-accent)';
                }
            });
            }

            if (isOpen) {
            panel.classList.add('hidden');
            btn.setAttribute('aria-expanded', 'false');
            if (icon) icon.style.transform = '';
            item.style.borderColor = 'var(--color-accent)';
            } else {
            panel.classList.remove('hidden');
            btn.setAttribute('aria-expanded', 'true');
            if (icon) icon.style.transform = 'rotate(180deg)';
            item.style.borderColor = 'var(--color-primary)';
            }
        });
        });

        if (openFirst) {
        const first = container.querySelector('[data-faq-trigger]');
        if (first) first.click();
        }
    });

    // Product card quick add: add to cart and open drawer.
    const updateCartBadge = (itemCount) => {
        const cartToggle = document.getElementById('CartToggle');
        if (!cartToggle) return;

        const currentCount = cartToggle.querySelector('#CartCount');
        const currentDot = cartToggle.querySelector('#CartCountDot');
        const createCountBadge = () => {
            const badge = document.createElement('span');
            badge.id = 'CartCount';
            badge.className = 'absolute -top-1.5 -end-1.5 min-w-[18px] h-[18px] px-1 rounded-full flex items-center justify-center leading-none font-bold';
            badge.style.background = 'var(--color-primary)';
            badge.style.color = 'var(--color-button-text)';
            badge.style.fontSize = '10px';
            return badge;
        };

        if (itemCount > 0) {
            if (currentCount) {
                currentCount.textContent = String(itemCount);
                return;
            }

            const badge = createCountBadge();
            badge.textContent = String(itemCount);
            if (currentDot) {
                currentDot.replaceWith(badge);
            } else {
                cartToggle.appendChild(badge);
            }
            return;
        }

        if (currentCount) currentCount.remove();
        if (currentDot) currentDot.remove();
    };

    const getCurrentBadgeCount = () => {
        const countNode = document.querySelector('#CartToggle #CartCount');
        if (!countNode) return 0;
        const parsed = parseInt(countNode.textContent || '0', 10);
        return Number.isNaN(parsed) ? 0 : parsed;
    };

    const formatMoney = (cents) => {
        return '$' + (Number(cents || 0) / 100).toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,');
    };

    const cartRoot = () => {
        const match = window.location.pathname.match(/^(\/[a-z]{2}(?:-[a-z]{2})?)(?:\/|$)/i);
        if (match) return `${match[1]}/`;
        return '/';
    };

    const sameOriginUrl = (url) => {
        if (!url) return null;
        try {
            if (url.startsWith('http://') || url.startsWith('https://')) {
                const parsed = new URL(url);
                if (parsed.origin === window.location.origin) {
                    return parsed.pathname + parsed.search;
                }
                return null;
            }
            return url.startsWith('/') ? url : `/${url}`;
        } catch (e) {
            return null;
        }
    };

    const CART_DRAWER_SECTION = 'cart-drawer';

    const cartAddUrl = () =>
        sameOriginUrl(window.ThemeRoutes?.cartAdd) || `${cartRoot()}cart/add.js`;
    const cartAddHtmlUrl = () =>
        sameOriginUrl(window.ThemeRoutes?.cartAddHtml) || `${cartRoot()}cart/add`;
    const cartChangeUrl = () =>
        sameOriginUrl(window.ThemeRoutes?.cartChange) || `${cartRoot()}cart/change.js`;
    const cartGetUrl = () =>
        sameOriginUrl(window.ThemeRoutes?.cartGet) || `${cartRoot()}cart.js`;
    const cartSectionsUrl = () =>
        sameOriginUrl(window.ThemeRoutes?.cartSections) || `${cartRoot()}?sections=${CART_DRAWER_SECTION}`;

    const parseCartError = async (response) => {
        const text = await response.text();
        try {
            const errorData = JSON.parse(text);
            return errorData.description || errorData.message || `Cart error (HTTP ${response.status})`;
        } catch (parseError) {
            return `Cart error (HTTP ${response.status})`;
        }
    };

    const buildCartFormData = (id, qty) => {
        const formData = new FormData();
        formData.append('form_type', 'product');
        formData.append('utf8', '✓');
        formData.append('id', id);
        formData.append('quantity', String(qty));
        return formData;
    };

    const isLocalThemeDev = () =>
        /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname);

    const getStorePreviewUrl = () => {
        const shopUrl = window.ThemeRoutes?.shopUrl;
        const themeId = window.ThemeRoutes?.previewThemeId;
        if (!shopUrl || !themeId) return null;
        const base = shopUrl.endsWith('/') ? shopUrl.slice(0, -1) : shopUrl;
        return `${base}?preview_theme_id=${themeId}`;
    };

    const applyCartDrawerFromDoc = (nextDoc) => {
        const nextDrawer = nextDoc.getElementById('CartDrawer');
        const currentDrawer = document.getElementById('CartDrawer');
        if (!nextDrawer || !currentDrawer) return false;

        const wasOpen = window.isCartOpen ? window.isCartOpen() : false;
        const panelInner = currentDrawer.querySelector('#CartDrawerPanel > div');

        const nextItems = nextDoc.getElementById('CartItems');
        const currentItems = document.getElementById('CartItems');
        if (nextItems && currentItems) {
            currentItems.innerHTML = nextItems.innerHTML;
        }

        const nextCount = nextDoc.getElementById('CartDrawerCount');
        const currentCount = document.getElementById('CartDrawerCount');
        if (nextCount && currentCount) {
            currentCount.textContent = nextCount.textContent;
            currentCount.classList.toggle('hidden', nextCount.classList.contains('hidden'));
        } else {
            const nextTitle = nextDrawer.querySelector('h2');
            const currentTitle = currentDrawer.querySelector('h2');
            if (nextTitle && currentTitle) currentTitle.innerHTML = nextTitle.innerHTML;
        }

        const nextFooter = nextDoc.getElementById('CartDrawerFooter');
        const currentFooter = document.getElementById('CartDrawerFooter');
        if (nextFooter && currentFooter) {
            currentFooter.replaceWith(nextFooter.cloneNode(true));
        } else if (nextFooter && !currentFooter && panelInner) {
            panelInner.appendChild(nextFooter.cloneNode(true));
        } else if (!nextFooter && currentFooter) {
            currentFooter.remove();
        } else {
            const nextFooterLegacy = nextDrawer.querySelector('#CartDrawerPanel .border-t.space-y-4');
            const currentFooterLegacy = currentDrawer.querySelector('#CartDrawerPanel .border-t.space-y-4');
            if (nextFooterLegacy && currentFooterLegacy) {
                currentFooterLegacy.replaceWith(nextFooterLegacy.cloneNode(true));
            } else if (!nextFooterLegacy && currentFooterLegacy) {
                currentFooterLegacy.remove();
            }
        }

        if (wasOpen && window.restoreCartOpen) {
            window.restoreCartOpen();
        }
        return true;
    };

    const applyCartDrawerSectionHtml = (html) => {
        if (!html) return false;
        const parser = new DOMParser();
        return applyCartDrawerFromDoc(parser.parseFromString(html, 'text/html'));
    };

    const addVariantToCart = async (variantId, quantity = 1) => {
        const id = String(variantId).trim();
        const qty = Math.max(1, Number(quantity) || 1);
        if (!id || !/^\d+$/.test(id)) {
            throw new Error('Invalid variant id');
        }

        const addUrl = cartAddUrl();
        let lastError = 'Failed to add item to cart';

        const tryPost = async (options) => {
            const response = await fetch(addUrl, {
                credentials: 'same-origin',
                ...options
            });
            if (response.ok) return response.json();
            lastError = await parseCartError(response);
            return null;
        };

        // 1. Dawn-style: sections + items (Shopify-recommended AJAX cart)
        let data = await tryPost({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/javascript'
            },
            body: JSON.stringify({
                items: [{ id, quantity: qty }],
                sections: CART_DRAWER_SECTION,
                sections_url: window.location.pathname
            })
        });
        if (data) return data;

        // 2. Bare FormData with Shopify form fields
        data = await tryPost({ method: 'POST', body: buildCartFormData(id, qty) });
        if (data) return data;

        // 3. Product form fields when on PDP
        const productForm = document.querySelector('#product-form, #product-form-cart');
        if (productForm) {
            const fd = new FormData(productForm);
            fd.set('id', id);
            fd.set('quantity', String(qty));
            if (!fd.has('form_type')) fd.set('form_type', 'product');
            if (!fd.has('utf8')) fd.set('utf8', '✓');
            data = await tryPost({ method: 'POST', body: fd });
            if (data) return data;
        }

        // 4. Legacy JSON body
        data = await tryPost({
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json'
            },
            body: JSON.stringify({ id, quantity: qty })
        });
        if (data) return data;

        // 5. HTML /cart/add (when /cart/add.js is blocked by bot protection)
        const htmlResponse = await fetch(cartAddHtmlUrl(), {
            method: 'POST',
            credentials: 'same-origin',
            body: buildCartFormData(id, qty),
            redirect: 'manual'
        });

        if (
            htmlResponse.ok ||
            htmlResponse.status === 302 ||
            htmlResponse.status === 303 ||
            htmlResponse.type === 'opaqueredirect'
        ) {
            const cart = await fetchCart();
            try {
                await syncCartDrawerContent();
            } catch (syncError) {
                // Drawer sync is best-effort after HTML add.
            }
            return { item_count: cart.item_count || 0, sections: {} };
        }

        if (String(lastError).includes('403') || htmlResponse.status === 403) {
            const preview = getStorePreviewUrl();
            const hint = isLocalThemeDev() && preview
                ? ` Open the store preview instead of localhost: ${preview}`
                : ' Hard-refresh the page and try again.';
            throw new Error(`Cart blocked (403).${hint}`);
        }
        throw new Error(lastError);
    };

    const postCartChange = async ({ id, line, quantity }) => {
        const payload = { quantity: Number(quantity) };
        if (id) payload.id = id;
        if (line) payload.line = Number(line);

        const response = await fetch(cartChangeUrl(), {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify(payload)
        });
        if (!response.ok) throw new Error('Failed to update cart line');
        return response.json();
    };

    const fetchCart = async () => {
        const response = await fetch(`${cartGetUrl()}?t=${Date.now()}`, {
            credentials: 'same-origin',
            cache: 'no-store'
        });
        if (!response.ok) throw new Error('Failed to fetch cart');
        return response.json();
    };

    const syncCartDrawerContent = async () => {
        const response = await fetch(cartSectionsUrl(), { credentials: 'same-origin' });
        if (!response.ok) throw new Error('Failed to fetch cart drawer section');
        const sections = await response.json();
        const drawerMarkup = sections[CART_DRAWER_SECTION];
        if (!drawerMarkup) throw new Error('Missing cart drawer markup');
        applyCartDrawerSectionHtml(drawerMarkup);
    };

    const afterCartAdd = async (addResponse, quantityAdded) => {
        let nextCount = null;

        if (typeof addResponse?.item_count === 'number') {
            nextCount = addResponse.item_count;
        }

        if (nextCount === null) {
            try {
                const cart = await fetchCart();
                nextCount = cart.item_count || 0;
            } catch (cartError) {
                nextCount = getCurrentBadgeCount() + quantityAdded;
            }
        }

        updateCartBadge(nextCount);
        const wasOpen = window.isCartOpen && window.isCartOpen();

        const sectionHtml = addResponse?.sections?.[CART_DRAWER_SECTION];
        if (!sectionHtml || !applyCartDrawerSectionHtml(sectionHtml)) {
            try {
                await syncCartDrawerContent();
            } catch (drawerError) {
                // Keep counter update even if drawer section refresh is rate-limited.
            }
        }

        if (!wasOpen && window.openCart) window.openCart();
    };

    const addToCartAndOpenDrawer = async (button) => {
        const variantId =
            document.getElementById('main-variant-id')?.value ||
            document.querySelector('#product-form-cart input[name="id"]')?.value ||
            document.querySelector('#product-form input[name="id"]')?.value;
        const qtyInput = document.getElementById('qty-input') || document.getElementById('qty-input-simple');
        const quantity = Math.max(1, parseInt(qtyInput?.value || '1', 10));

        if (!variantId || button.dataset.loading === 'true') {
            if (!variantId) console.error('Add to cart: select a variant first');
            return;
        }

        const label = button.querySelector('[id^="atc-label"]');
        const defaultLabel = button.dataset.addLabel || label?.textContent || '';

        button.dataset.loading = 'true';
        button.disabled = true;
        button.classList.add('opacity-70');
        if (label) label.textContent = 'Adding…';

        try {
            const addResponse = await addVariantToCart(variantId, quantity);
            await afterCartAdd(addResponse, quantity);
        } catch (error) {
            console.error('Add to cart failed:', error.message, {
                variantId,
                url: cartAddUrl()
            });
        } finally {
            button.dataset.loading = 'false';
            if (!button.classList.contains('cursor-not-allowed')) {
                button.disabled = false;
                button.classList.remove('opacity-70');
            }
            if (label) label.textContent = defaultLabel;
        }
    };

    const handleCartLineAction = async (trigger, { itemKey, nextQty }) => {
        if (!itemKey || trigger.dataset.loading === 'true') return;
        trigger.dataset.loading = 'true';
        trigger.disabled = true;

        try {
            const cart = await postCartChange({ id: itemKey, quantity: nextQty });
            updateCartBadge(cart.item_count || 0);

            const sectionHtml = cart.sections?.[CART_DRAWER_SECTION];
            if (sectionHtml) {
                applyCartDrawerSectionHtml(sectionHtml);
            } else {
                try {
                    await syncCartDrawerContent();
                } catch (syncError) {
                    const row = trigger.closest('[data-cart-item-key]');
                    const input = row?.querySelector('.js-qty-input');
                    const linePriceNode = row?.querySelector('.js-line-price');
                    const updatedItem = (cart.items || []).find((item) => item.key === itemKey);
                    if (nextQty === 0 && row) {
                        row.closest('[data-cart-item]')?.remove();
                    } else if (input) {
                        input.value = String(nextQty);
                    }
                    if (linePriceNode && updatedItem) {
                        linePriceNode.textContent = formatMoney(updatedItem.final_line_price);
                    }
                    const subtotal = document.getElementById('CartSubtotal');
                    if (subtotal) subtotal.textContent = formatMoney(cart.total_price);
                    if (window.isCartOpen && window.isCartOpen() && window.restoreCartOpen) {
                        window.restoreCartOpen();
                    }
                }
            }
        } catch (error) {
            console.error('Cart line update failed:', error);
        } finally {
            trigger.dataset.loading = 'false';
            trigger.disabled = false;
        }
    };

    document.addEventListener('click', async (event) => {
        const productBtn = event.target.closest('[data-product-add-button]');
        if (productBtn) {
            event.preventDefault();
            await addToCartAndOpenDrawer(productBtn);
            return;
        }

        const quickBtn = event.target.closest('[data-quick-add-button]');
        if (quickBtn) {
            event.preventDefault();
            event.stopPropagation();

            const variantId = quickBtn.dataset.variantId;
            if (!variantId || quickBtn.dataset.loading === 'true') return;
            quickBtn.dataset.loading = 'true';
            quickBtn.disabled = true;

            try {
                const addResponse = await addVariantToCart(variantId, 1);
                await afterCartAdd(addResponse, 1);
            } catch (error) {
                console.error('Quick add failed:', error);
            } finally {
                quickBtn.dataset.loading = 'false';
                quickBtn.disabled = false;
            }
            return;
        }

        const removeBtn = event.target.closest('.js-cart-remove');
        if (removeBtn) {
            event.preventDefault();
            handleCartLineAction(removeBtn, {
                itemKey: removeBtn.dataset.itemKey,
                nextQty: 0
            });
            return;
        }

        const qtyButton = event.target.closest('.js-qty-btn');
        if (!qtyButton) return;

        const row = qtyButton.closest('[data-cart-item-key]');
        if (!row) return;

        event.preventDefault();
        const input = row.querySelector('.js-qty-input');
        const itemKey = row.getAttribute('data-cart-item-key');
        const delta = parseInt(qtyButton.dataset.delta || '0', 10);
        const currentQty = parseInt(input?.value || '1', 10);
        const nextQty = Math.max(0, currentQty + delta);
        if (!itemKey || !input || nextQty === currentQty) return;

        handleCartLineAction(qtyButton, { itemKey, nextQty });
    });

    // Prevent GET /cart/change links (quantity=0 remove links) to avoid rate-limit spikes.
    document.addEventListener('click', async (event) => {
        const changeLink = event.target.closest('a[href*="/cart/change"]');
        if (!changeLink) return;

        const href = changeLink.getAttribute('href') || '';
        let url;
        try {
            url = new URL(href, window.location.origin);
        } catch (e) {
            return;
        }
        if (!url.pathname.includes('/cart/change')) return;

        const quantity = url.searchParams.get('quantity');
        const id = url.searchParams.get('id');
        const line = url.searchParams.get('line');
        if (quantity === null || (!id && !line)) return;

        event.preventDefault();
        if (changeLink.dataset.loading === 'true') return;
        changeLink.dataset.loading = 'true';

        try {
            const cart = await postCartChange({ id, line, quantity });
            updateCartBadge(cart.item_count || 0);

            if (document.body.classList.contains('template-cart') || window.location.pathname === '/cart') {
                window.location.reload();
                return;
            }

            const wasOpen = window.isCartOpen && window.isCartOpen();
            await syncCartDrawerContent();
            if (wasOpen && window.restoreCartOpen) window.restoreCartOpen();
        } catch (error) {
            console.error('Cart change link update failed:', error);
        } finally {
            changeLink.dataset.loading = 'false';
        }
    });

    // Prevent duplicate cart form submits and route quantity updates via AJAX.
    document.addEventListener('submit', async (event) => {
        const form = event.target;
        if (!(form instanceof HTMLFormElement)) return;

        const action = form.getAttribute('action') || '';
        const isCartForm = action.includes('/cart') && !action.includes('/cart/add');
        if (!isCartForm) return;

        if (form.dataset.submitting === 'true') {
            event.preventDefault();
            return;
        }

        const updatesInputs = form.querySelectorAll('input[name="updates[]"]');
        const hasUpdates = updatesInputs.length > 0;
        const discountInput = form.querySelector('input[name="discount"]');
        const hasDiscountValue = Boolean(discountInput && String(discountInput.value || '').trim().length > 0);
        const onCartPage = window.location.pathname === '/cart' || document.body.classList.contains('template-cart');

        if (onCartPage && hasUpdates && !hasDiscountValue) {
            event.preventDefault();
            form.dataset.submitting = 'true';
            form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((button) => {
                button.disabled = true;
            });

            try {
                const formData = new FormData();
                updatesInputs.forEach((input) => {
                    formData.append('updates[]', input.value || '0');
                });
                const response = await fetch(`${cartRoot()}cart/update.js`, {
                    method: 'POST',
                    credentials: 'same-origin',
                    body: formData
                });
                if (!response.ok) throw new Error('Failed to update cart');
                window.location.reload();
            } catch (error) {
                console.error('Cart form AJAX update failed:', error);
                form.submit();
            }
            return;
        }

        form.dataset.submitting = 'true';
        form.querySelectorAll('button[type="submit"], input[type="submit"]').forEach((button) => {
            button.disabled = true;
        });
    }, true);
});
